export const TRIAL = '/trial'
export const REQUEST_CHARTS_URL = 'request-charts'
